import { lazy } from "react";
import RenderSubSection from "./RenderSubSections";

const UsersList = lazy(() => import("pages/Users/list"));
const UserForm = lazy(() => import("pages/Users/UserForm"));

const UserList = {
    name: "لیست کاربر‌ها",
    path: "/user-list",
    group: "user-list",
    exact: true,
    component: () => <UsersList />,
};

const userCreate = {
    name: "ثبت کاربر جدید",
    path: "/new-user",
    group: "new-user",
    isHide: true,
    component: () => <UserForm />,
};

const userUpdate = {
    name: "به روز رسانی کاربر",
    path: "/update-user/:id",
    group: "update-user",
    isHide: true,
    component: () => <UserForm />,
};

const subSections = {
    user: {
        list: { ...UserList },
        create: { ...userCreate },
        update: { ...userUpdate },
    },
};

const userSection = {
    title: "کاربر",
    key: "user",
    SubRoutes: (keywords: any) => RenderSubSection(keywords, subSections),
};

export default userSection;
